var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-adjust-balance-dialog",
          attrs: {
            visible: _vm.visible,
            title: _vm.showDetailTitle,
            width: "370px",
            "close-on-click-modal": false,
            "show-close": true
          },
          on: { close: _vm.cancel }
        },
        [
          _c(
            "div",
            [
              _c("cargo-ag-grid", {
                staticClass: "ag-theme-balham",
                staticStyle: { width: "350px", height: "300px" },
                attrs: {
                  "locale-text-func": _vm._i18nGridLocalText,
                  "grid-options": _vm.gridOptionsFileDetail,
                  "column-defs": _vm.columnDefsFileDetail,
                  "row-data": _vm.rowDataFileDetail,
                  "enable-col-resize": true,
                  "enable-sorting": true
                },
                on: {
                  gridReady: function(params) {
                    return (_vm.gridApiFileDetail = params.api)
                  }
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }